import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { useSelector, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";
//Autocomplete
import Autocomplete from "@material-ui/lab/Autocomplete";
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import { Link } from "react-router-dom";
import UpdateSlipInventory from "../UpdateSlipInventory/UpdateSlipInventory";
import {
  AddBox,
  Check,
  DeleteOutline,
  Edit,
  SaveAlt,
  FilterList,
  FirstPage,
  LastPage,
  ChevronRight,
  ChevronLeft,
  Clear,
  Search,
  ArrowDownward,
  Remove,
  ViewColumn,
} from "@material-ui/icons";

const api = axios.create({
  baseURL: "InventoryMasterDetails",
});

const apiSlip = axios.create({
  baseURL: "SlipGeneration",
});

export const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
  )),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => (
    <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
  )),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
export const tableIconsInputScreen = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => (
    <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
  )),
  Clear: forwardRef((props, ref) => (
    <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
  )),
  Delete: forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
  )),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => (
    <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
  )),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => (
    <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
  )),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);
const data = [
  {
    id: "12345678",
    firstName: "HYDERABAD",
    lastName: "16.5",
    emailId: "sriyanka",
    phone: "9/01/2023  ",
  },
];

export default function ModifyInventory(props) {
  //const classes = useStyles();

  //for progress
  var columns = [
    { title: "slipId", field: "slipId", hidden: true },
    { title: "Slip Number", field: "slipnumber" },
    { title: "Plant Id", field: "plantname" },
    { title: "Location", field: "locationName" },
    { title: "Material Number", field: "materialName" },
    { title: "Material Name", field: "materialDescription" },
    { title: "ABC Classification", field: "abcclassiification" },
    { title: "Measuring Unit", field: "unitOfMeasurement" },
    {
      title: "Entered Quantity",
      field: "countedPhyQuantity",
      type: "numeric",
      align: "left",
    },
    { title: "Comment", field: "remarks" },
    { title: "Entered By", field: "slipCreatedBy" },
    { title: "Entered On", field: "createdDate" },
    { title: "Modified By", field: "slipModifieddBy" },
    { title: "Modified On", field: "modifiedDate" },
  ];

  const [openLoader, setopenLoader] = useState(false);

  //for Warning showing
  const [openWarning, setopenWarning] = useState(false);
  const [openAlertWarning, setopenAlertWarning] = useState("");
  const [openClassNameWarning, setopenClassNameWarning] = useState("");
  const [openTypeWarning, setopenTypeWarning] = useState("");
  const [alertwarningclass, setalertwarningclass] =
    useState("bg-amber clr-white");
  const [alertwarning, setalertwarning] = useState("Warning");

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [severity, setSeverity] = useState("success");

  const token = useSelector((state) => state.saveAzureTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken
  );
  const uId = useSelector((state) => state.saveUIDReducer.uid);

  //Autocomplete
  const [employeeObj, setEmployeeObj] = useState("");
  const [employeeText, setEmployeeText] = useState("");
  const [phyInvWorkflow, setphyInvWorkflow] = useState("");
  const handleChangeEmployee = (event, newValue) => {
   // console.log(newValue);
    setEmployeeObj(newValue ? newValue : []);
    setEmployeeText(newValue ? newValue.empName : "");
    setemployeeValue(newValue ? newValue.employeeId : 0);
  };

  const handleChangeEmployeeInput = (event, newInputValue) => {
    setEmployeeText(newInputValue ? newInputValue : " ");
  };

  const handleErrorClose = (e) => {
    setIserror(false);
  };

  function handleCloseWarning() {
    setopenWarning(false);
  }

  //function getURLParameter(sParam) {
  //    var sPageURL = window.location.search.substring(1);
  //    var sURLVariables = sPageURL.split('&');
  //    for (var i = 0; i < sURLVariables.length; i++) {
  //        var sParameterName = sURLVariables[i].split('=');
  //        var value = '';
  //        for (var j = 0; j < sParameterName.length; j++) {
  //            if (sParameterName[j] == sParam) {
  //                for (var k = j + 1; k < sParameterName.length; k++) {
  //                    value = value + sParameterName[k];
  //                }
  //                break;
  //            }
  //            else {
  //                continue;
  //            }
  //        }
  //        return value;
  //    }
  //}
  const tableHeaderStyle = {
    backgroundColor: "var(--light-sand)",
    color: "var(--dark-blue)",
  };
  const tableOptions = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 5,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    //paging: false,
    maxBodyHeight: "600px",
    // exportButton: true,
    // exportAllData: true
  };
  function getURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split("&");
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split("=");
      var value = getParamName(sParameterName, sParam);
      return value;
    }
  }

  function getParamName(sParameterName, sParam) {
    var value = "";
    for (var j = 0; j < sParameterName.length; j++) {
      if (sParameterName[j] == sParam) {
        value = value + getParanValue(j, sParameterName);
        break;
      } else {
        continue;
      }
    }
    return value;
  }
  function GetEditButton(rowData) {
    return (
      <Tooltip title="Modify Slip" placement="bottom">
        <span>
          <Button href="javascript:void(0)">
            <span>
              <EditOutlinedIcon fontSize="small" className="attachFileIcon" />
            </span>
          </Button>
        </span>
      </Tooltip>
    );
  }

  function getParanValue(j, sParameterName) {
    var value = "";
    for (var k = j + 1; k < sParameterName.length; k++) {
      value = value + sParameterName[k];
    }
    return value;
  }

  const today = Date.now();
  let newdateformat = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(today);
  let ldate =
    newdateformat.split("/")[2] +
    "-" +
    newdateformat.split("/")[0] +
    "-" +
    newdateformat.split("/")[1];
  const [entrydate, setentrydate] = useState(ldate);
  const [isDisabled, setisDisabled] = useState(true);
  const [employee, setemployee] = useState([]);
  const [employeeValue, setemployeeValue] = useState("");
  //const [employeeNameValue, setEmployeeNameValue] = useState("");
  //const [employeeNames, setEmployeeNames] = useState([]);
  const [mrp, setmrp] = useState([]);
  const [time, settime] = useState([]);
  const [date, setdate] = useState([]);
  const [mrpValue, setmrpValue] = useState("");
  const [shiftValue, setshiftValue] = useState("");
  const [slipGenId, setslipGenId] = useState(
    window.atob(getURLParameter("ID"))
      ? window.atob(getURLParameter("ID"))
      : props.SlipGenId
  );
  const [EntryNumberValue, setEntryNumberValue] = useState("");
  const [ViewEntryNumberValue, setViewEntryNumberValue] = useState("");
  const [WorkerShift, setWorkerShift] = useState([]);
  const [EnteredTimeValue, setEnteredTimeValue] = useState("");
  const [InputTimeValue, setInputTimeValue] = useState("");
  const [IdleTimeValue, setIdleTimeValue] = useState("");
  const [EfficiencyValue, setEfficiencyValue] = useState("");
  const [slipDataDetails, setslipDataDetails] = useState([]);
  const [slipDataPlanTime, setslipDataPlanTime] = useState([]);
  const [slipDataUnPlanTime, setslipDataUnPlanTime] = useState([]);
  const [slipDataIHFTime, setslipDataIHFTime] = useState([]);
  const [PlanTimeValue, setPlanTimeValue] = useState([]);
  const [UnPlanTimeValue, setUnPlanTimeValue] = useState([]);
  const [IHFTimeValue, setIHFTimeValue] = useState([]);
  const [NoWorkValue, setNoWorkValue] = useState(0);
  const [CreatedBy, setCreatedBy] = useState(
    props.loginuser.response.firstName + " " + props.loginuser.response.lastName
  );
  const [CreatedUserId, setCreatedUserId] = useState(
    props.loginuser.response.employeeId
  );
  const [isSubmitDisabled, setisSubmitDisabled] = useState(true);
  const [ViewEfficiencyValue, setViewEfficiencyValue] = useState("");
  const [open, setopen] = useState(false);
  const [openAlert, setopenAlert] = useState("");
  const [openClassName, setopenClassName] = useState("");
  const [openType, setopenType] = useState("");
  //const [alertsuccess, setalertsuccess] = useState("Success");
  //const [alerterror, setalerterror] = useState("Alert");
  //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
  //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
  //new
  const [Remarks, setRemarks] = useState("");
  const [place, setPlace] = useState([]);
  const [placeValue, setPlaceValue] = useState("");
  const [loc, setLoc] = useState("");
  const [matNo, setMatNo] = useState("");
  const [matDesc, setMatDesc] = useState("");
  const [classification, setClassification] = useState("");
  const [unit, setUnit] = useState("");
  const [physical, setPhysical] = useState("");
  const [plant, setPlant] = useState([]);
  //for location and material
  const [phyInvlocation, setphyInvlocation] = useState([]);
  const [phyInvlocationName, setphyInvlocationName] = useState("");
  const [phyInvlocationID, setphyInvlocationID] = useState("");
  const [phyInvlocationObj, setphyInvlocationObj] = useState("");
  const [phyInvMaterial, setphyInvMaterial] = useState([]);
  const [phyInvMaterialName, setphyInvMaterialName] = useState("");
  const [phyInvMaterialID, setphyInvMaterialID] = useState("");
  const [phyInvMaterialObj, setphyInvMaterialObj] = useState("");
  //for measuringUnit
  const [MeasuringUnit, setMeasuringUnit] = useState([]);
  const [MeasuringUnitObj, setMeasuringUnitObj] = useState([]);
  const [MeasuringUnitName, setMeasuringUnitName] = useState([]);

  //for abc classification
  const [AbcClassification, setAbcClassification] = useState([]);
  const [AbcClassificationObj, setAbcClassificationObj] = useState([]);
  const [AbcClassificationName, setAbcClassificationName] = useState([]);
  const [slipNumber, setSlipnumber] = useState("");
  const [viewSlipData, setviewSlipData] = useState([]);
  const [openForm, setopenForm] = useState(false);
  const [editRowData, seteditRowData] = useState([]);
  const [mode, setMode] = useState("");

  function handleeditFormClose() {
    setopenForm(false);
  }
  const goBackonClick = (obj) => {
    setopenForm(false);
    setopenLoader(false);
   // console.log("obj", obj);
    if (obj) {
      GetViewSlipDetails();
      //let errorList = [];
      //if (obj.result.objResult) {
      //}
      //errorList.push(obj.result.responseMsg);
      //if (obj.result.response) {
      //    showMessage(errorList, true, 'success');
      //}
      //else {
      //    showMessage(errorList, true, 'error');
      //}
    }
  };


    const handlePlace = async (event) => {
        setPlaceValue(event.target.value);
        await BindMaterialDetails(event.target.value);
        await getLocation(event.target.value);
        /*await getMaterial();*/
        //getMaterial(event.target.value);
       // handleChangephyInvlocation(event.target.value);
       // handleChangephyInvlocationInput(event.target.value);
        

    }
    //for selection from dropdown
    const handleChangephyInvlocation = async (event, newValue) => {
       // console.log("plantmodify", newValue);
        setphyInvlocationObj(newValue ? newValue : []);
        setphyInvlocationName(newValue ? newValue.locationName : "");
        setphyInvlocationID(newValue ? newValue.locationId : 0);
        
    };
    //fie actual whole dropdown data
    const handleChangephyInvlocationInput = (event, newInputValue) => {
        //console.log("plantIdInput", newInputValue);
        setphyInvlocationName(newInputValue ? newInputValue : "");
    };

  //measuring unit handle
  const handleChangephyInvMeasuringUnit = async (event, newValue) => {
    setMeasuringUnitObj(newValue ? newValue : []);
    setMeasuringUnitName(newValue ? newValue.bun : "");
  };
  const handleChangephyInvMeasuringUnitInput = (event, newInputValue) => {
    setMeasuringUnitName(newInputValue ? newInputValue : "");
  };

  //ABC handle
  const handleChangephyInvAbcClassification = async (event, newValue) => {
    setAbcClassificationObj(newValue ? newValue : []);
    setAbcClassificationName(newValue ? newValue.Abcindicator : "");
  };
  const handleChangephyInvAbcClassificationInput = (event, newInputValue) => {
    setAbcClassificationName(newInputValue ? newInputValue : "");
  };

  //material
  async function BindMaterialDetails(plantId) {
    setopenLoader(true);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    let PhyInvInputData = {
      plantId: Number(plantId),
    };

    api
      .post("/GetPhyInvMaterialNo/", PhyInvInputData,{headers: headers})
      .then((res) => {
        setphyInvMaterial(res.data);
       // console.log("MaterialDetails", res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. PhyInvLocation");
        setopenLoader(false);
      });
  }
  const handleChangephyInvMaterial = async (event, newValue) => {
    setphyInvMaterialObj(newValue ? newValue : []);
    setphyInvMaterialName(newValue ? newValue.materialName : "");
    setphyInvMaterialID(newValue ? newValue.materialId : 0);
  };
  const handleChangephyInvMaterialInput = (event, newInputValue) => {
    setphyInvMaterialName(newInputValue ? newInputValue : "");
  };
  const handleslipNumber = (event) => {
    setSlipnumber(event.target.value);
  };

  //new handles
  //const handlePlace = (event) => {
  //    setPlaceValue(event.target.value);
  //}

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };
  const handleLoc = (event) => {
    setLoc(event.target.value);
  };
  const handleMatNo = (event) => {
    setMatNo(event.target.value);
  };
  const handleMatDesc = (event) => {
    setMatDesc(event.target.value);
  };
  const handleClassification = (event) => {
    setClassification(event.target.value);
  };
  const handleUnit = (event) => {
    setUnit(event.target.value);
  };
  const handlePhysical = (event) => {
    setPhysical(event.target.value);
  };
  //const handleChangeEmp = (event) => {
  //    setemployeeValue(event.target.value);
  //};

  const handleChangeMrp = (event) => {
    setmrpValue(event.target.value);
  };

  const handleChangeShift = (event) => {
    setshiftValue(event.target.value);
  };

  const loca = ["Hyderabad", "Pune", "Mumbai", "Delhi", "Thane"];
  const mat = ["1234", "3456", "4567", "5678"];

  function calculateEfficiency_manual(
    enteredTimeValue,
    inputTimeValue,
    idleTimeValue,
    noWorkValue
  ) {
    //let idletime = ((inputTimeValue - idleTimeValue) + noWorkValue);
    let idletime = inputTimeValue - idleTimeValue - noWorkValue;
    let efficiency = 0;
    if (inputTimeValue > idleTimeValue) {
      efficiency = enteredTimeValue / idletime;
      efficiency = efficiency * 100;
      efficiency = efficiency.toFixed(2);
    }
    setEfficiencyValue(efficiency.toString());
    setViewEfficiencyValue(efficiency.toString() + "%");
  }

  function calculateEfficiency() {
    //let idletime = ((InputTimeValue - IdleTimeValue) + NoWorkValue);
    let idletime = InputTimeValue - IdleTimeValue - NoWorkValue;
    let efficiency = 0;
    if (InputTimeValue > IdleTimeValue) {
      efficiency = EnteredTimeValue / idletime;
      efficiency = efficiency * 100;
      efficiency = efficiency.toFixed(2);
    }
    setEfficiencyValue(efficiency.toString());
    setViewEfficiencyValue(efficiency.toString() + "%");
  }
  function clickEdit(rowData) {
   // console.log(rowData);
    setMode("edit");
    setopenForm(true);
    seteditRowData(rowData);

    //window.location.href = "/UpdateSlipInventory";
  }

  function handleClose() {
    setopen(false);
  }
  function showMessage(errorList, flag, severity) {
    setErrorMessages(errorList);
    setIserror(flag);
    setSeverity(severity);
  }

  async function GetViewSlipDetails() {
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    let isValidate = true;
    let errorList = [];
    if (placeValue == "" || placeValue === null || placeValue === undefined) {
      isValidate = false;
      errorList.push("Select Plant Name");
      showMessage(errorList, true, "error");
    }
    if (isValidate) {
      setopenLoader(true);
      let slipparam = {
        PlantId: Number(placeValue),
        LocationId: Number(phyInvlocationID),
        MaterialId: Number(phyInvMaterialID),
        CreatedBy: Number(employeeValue),
        Abcclassiification: AbcClassificationName,
        UnitOfMeasurement: MeasuringUnitName,
        Slipnumber: slipNumber,
      };
      await api
        .post("/geViewSlipDetails/", slipparam,{
           headers: headers
        })
        .then((res) => {
          //if (res.data.length <= 0) {
          //    errorList.push("This plant has no active workflow");
          //    showMessage(errorList, true, 'error');
          //}
          if (
            res.data.combinationavalialble == 0 &&
            res.data.plantvaluesavailable == 1 &&
            res.data.getresultViewSlip.length <= 0
          ) {
            errorList.push("This plant has no data available");
            showMessage(errorList, true, "error");
            setviewSlipData([]);
            //setphyInvlocationName("");
            //setPlaceValue("");
            //setphyInvMaterialName("");
            //setphyInvMaterialID("");
            clear();
          } else if (
            res.data.combinationavalialble == 0 &&
            res.data.plantvaluesavailable == 0 &&
            res.data.getresultViewSlip.length <= 0
          ) {
            errorList.push("This plant has no active workflow");
            showMessage(errorList, true, "error");
            setviewSlipData([]);
            //setPlaceValue("");
            //setphyInvlocationName("");
            //setphyInvMaterialName("");
            //setphyInvMaterialID("");
            clear();
          } else {
            setviewSlipData(res.data.getresultViewSlip);
           // console.log("viewSlip", res.data);
          }
          setopenLoader(false);
        })
        .catch((error) => {
          console.log("Error in hitting api : SlipGenDetails");
          setopenLoader(false);
        });
    }
  }

  //NEW FUNCS
  function clear() {
    setPlaceValue("");
    setphyInvlocationName("");
    setphyInvlocationID("");
    setphyInvlocationObj("");
    setphyInvMaterial([]);
    setphyInvMaterialName("");
    setphyInvMaterialID("");
    setphyInvMaterialObj("");
    setSlipnumber("");
    setEmployeeObj("");
    setemployeeValue("");
    setEmployeeText("");
    setAbcClassificationName("");
    setAbcClassificationObj("");
    setMeasuringUnitName("");
    setMeasuringUnitObj("");
  }

  async function Refresh() {
    await GetViewSlipDetails();
  }

  useEffect(async () => {
    getPlant(props.loginuser.response.gid);
    // getLocation();
    //getMaterial();
    getEmployees(0);
    getMeasuringUnit();
    getAbcClassification();
  }, []);

  async function getEmployees(id) {
    const headers = {
        Authorization: "Bearer " + bearerToken,
        UserEmail: userDetails.emailId,
        userId: uId,
        RoleName: userDetails.roleName,
        Gid: userDetails.gid,
        Roleid: userDetails.roleId,
        //AzureToken: token,
      };
    setemployee([]);
    await api
      .get("/getAllEmployeeWorkers/",{
        headers: headers,
      })
      .then((res) => {
        //debugger;
        setemployee(res.data);
       // console.log("EMP Details", res.data);
        //let empData = [];
        //if (id > 0) {
        //    empData = res.data;
        //    empData.filter(x => x.employeeId == id).map(filtered => {
        //        console.log(filtered);
        //        setEmployeeObj(filtered);
        //        setEmployeeText(filtered.empName ? filtered.empName : "");
        //    });
        //}
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. Employee");
      });
  }

  async function getPlant(Id) {
    setopenLoader(true);
   // console.log("id", Id);
    const headers = {
        Authorization: "Bearer " + bearerToken,
        UserEmail: userDetails.emailId,
        userId: uId,
        RoleName: userDetails.roleName,
        Gid: userDetails.gid,
        Roleid: userDetails.roleId,
       // AzureToken: token,
      };
    await api
      .get("/getTblMstPlant/" + Id,{
        headers: headers,
      })
      .then((res) => {
        setPlant(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }

  async function getLocation(plantId) {
    setopenLoader(true);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
     // AzureToken: token,
    };
    let errorList = [];
    await api
      .get("/getPhyInvAllLocation/" + plantId,{
        headers: headers
      })
      .then((res) => {
        if (res.data.length <= 0) {
          errorList.push("This plant has no active workflow");
          showMessage(errorList, true, "error");
          setPlaceValue("");
          setphyInvlocationName("");
          setviewSlipData([]);
          setphyInvMaterialName("");
          setphyInvMaterialID("");
        }
        setphyInvlocation(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }

  async function getMaterial() {
      setopenLoader(true);
      const headers = {
          Authorization: "Bearer " + bearerToken,
          UserEmail: userDetails.emailId,
          userId: uId,
          RoleName: userDetails.roleName,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
          // AzureToken: token,
      };
    let errorList = [];
    await api
        .get("/getPhyInvAllMaterial/",{
            headers: headers
        })
      .then((res) => {
        if (res.data.length <= 0) {
          errorList.push("This plant has no active workflow");
          showMessage(errorList, true, "error");
          setPlaceValue("");
          setphyInvMaterialName("");
          setphyInvMaterialID("");

          setviewSlipData([]);
        }
        setphyInvMaterial(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }

  async function getMeasuringUnit() {
    setopenLoader(true);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    await api
      .get("/getMeasuringUnit/",{
        headers: headers,
      })
      .then((res) => {
        setMeasuringUnit(res.data);
       // console.log(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }

  //async function BindMaterialDetails(plantId) {
  //    setopenLoader(true);
  //    let PhyInvInputData = {
  //        plantId: Number(plantId),
  //    }

  //    api.post('/GetPhyInvMaterialNo/', PhyInvInputData)
  //        .then(res => {
  //            setphyInvMaterial(res.data);
  //            console.log("MaterialDetails", res.data);
  //            setopenLoader(false);

  //        })
  //        .catch(error => {
  //            console.log("Error in hitting api at page load. PhyInvLocation");
  //            setopenLoader(false);

  //        })
  //}

  function getAbcClassification() {
    setopenLoader(true);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    api
      .get("/getAbcClassification/",{
        headers: headers,
      })
      .then((res) => {
        setAbcClassification(res.data);
       // console.log("Hello", res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }
  return (
    <ThemeProvider theme={lightTheme}>
      <div className="master-layout-data">
        <Box paddingTop={{ xs: "5rem", sm: "2rem" }} className="">
          <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">
            View Slips{" "}
          </h3>
        </Box>
        <Grid
          container
          spacing={2}
          className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius "
        >
          <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
            <div>
              {iserror && (
                <Alert severity={severity} onClose={handleErrorClose}>
                  {errorMessages.map((msg, i) => {
                    return <div key={i}>{msg}</div>;
                  })}
                </Alert>
              )}
            </div>
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
            <TextField
              className="lightInputFields  "
              select
              id=""
              //disabled={true}
              label="Plant Name"
              variant="filled"
              fullWidth
              name=""
              value={placeValue}
              onChange={handlePlace}
            >
              {plant.map((h, i) => (
                <MenuItem key={i} value={h.plantId}>
                  {h.plantName}
                </MenuItem>
              ))}
              {/*<MenuItem value="">*/}
              {/*    <em>Select</em>*/}
              {/*</MenuItem>*/}
              {/*<MenuItem value={10}>Ten</MenuItem>*/}
              {/*<MenuItem value={20}>Twenty</MenuItem>*/}
              {/*<MenuItem value={30}>Thirty</MenuItem>*/}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
            {/*<TextField className="lightInputFields  "*/}
            {/*    //id="CreatedDate"*/}
            {/*    //disabled={true}*/}
            {/*    select*/}
            {/*    label="Location"*/}
            {/*    variant="filled"*/}
            {/*    fullWidth*/}
            {/*    // name="Created Date"*/}
            {/*    value={loc}*/}
            {/*    onChange={handleLoc}*/}
            {/*>*/}
            {/*    <MenuItem value="">*/}
            {/*        <em>Select</em>*/}
            {/*    </MenuItem>*/}
            {/*    <MenuItem value={10}>Ten</MenuItem>*/}
            {/*    <MenuItem value={20}>Twenty</MenuItem>*/}
            {/*    <MenuItem value={30}>Thirty</MenuItem>*/}
            {/*</TextField>*/}
            <Autocomplete
              className="lightInputFields"
              //disablePortal
              id="combo-box-demo"
              value={phyInvlocationObj}
              inputValue={phyInvlocationName}
              options={phyInvlocation}
              getOptionLabel={(option) =>
                option.locationName ? option.locationName : ""
              }
              onChange={handleChangephyInvlocation}
              onInputChange={handleChangephyInvlocationInput}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Location" />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <Autocomplete
              className="lightInputFields"
              //disablePortal
              id="combo-box-demo"
              value={phyInvMaterialObj}
              inputValue={phyInvMaterialName}
              options={phyInvMaterial}
              getOptionLabel={(option) =>
                option.materialName ? option.materialName : ""
              }
              onChange={handleChangephyInvMaterial}
              onInputChange={handleChangephyInvMaterialInput}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Material Number" />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
            <Autocomplete
              className="lightInputFields"
              id="combo-box-demo"
              fullWidth
              value={employeeObj}
              inputValue={employeeText}
              options={employee}
              getOptionLabel={(option) =>
                option.empName ? option.empName : ""
              }
              onChange={handleChangeEmployee}
              onInputChange={handleChangeEmployeeInput}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Slip Created By"
                  //required
                  //error={errorsupervisoryOrganization}
                  //helperText={errorTextsupervisoryOrganization}
                />
              )}
              //disabled={props.disableValue}
            />
            {/*<Autocomplete className="lightInputFields"*/}
            {/*    //disablePortal*/}
            {/*    id="combo-box-demo"*/}
            {/*    options={mat}*/}
            {/*    // sx={{ width: 300 }}*/}
            {/*    renderInput={(params) => <TextField {...params} label="Slip Created By" />}*/}
            {/*/>*/}
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
            <Autocomplete
              className="lightInputFields"
              //disablePortal
              id="combo-box-demo"
              value={AbcClassificationObj}
              inputValue={AbcClassificationName}
              options={AbcClassification}
              getOptionLabel={(option) =>
                option.abcindicator ? option.abcindicator : ""
              }
              onChange={handleChangephyInvAbcClassification}
              onInputChange={handleChangephyInvAbcClassificationInput}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="ABC Classification" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
            <Autocomplete
              className="lightInputFields"
              //disablePortal
              id="combo-box-demo"
              value={MeasuringUnitObj}
              inputValue={MeasuringUnitName}
              options={MeasuringUnit}
              getOptionLabel={(option) => (option.bun ? option.bun : "")}
              onChange={handleChangephyInvMeasuringUnit}
              onInputChange={handleChangephyInvMeasuringUnitInput}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Measuring Unit" />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1 ">
            <TextField
              className="lightInputFields"
              //disabled={true}
              label="Slip Number"
              variant="filled"
              fullWidth
              //name="Created Time"
              value={slipNumber}
              onChange={handleslipNumber}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={4}
            className="d-flex jc-center width-100"
          ></Grid>

          <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
            <Button className="ns-btn-primary mt-1 mr-1" onClick={Refresh}>
              <span>Refresh</span>
            </Button>
          </Grid>
          <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
            <Button className="ns-btn-primary mt-1 mr-1" onClick={clear}>
              <span>Reset</span>
            </Button>
          </Grid>
          {/*<Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={GetViewSlipDetails}  >
                           <span>Search</span>
                        </Button>
                    </Grid>*/}
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <MaterialTable
              title=""
              columns={columns}
              data={viewSlipData}
              //align={CenterFocusStrong}
              icons={tableIconsInputScreen}
              actions={[
                (rowData) => ({
                  icon: GetEditButton,
                  //icon: () => <Link to={"/UpdateSlipInventory?ID=" + `${window.btoa(rowData.slipId)}`}><EditOutlinedIcon fontSize="small" className="attachFileIcon" /></Link>,
                  tisFreeAction: true,
                  //onClick: (rowData)
                  onClick: (event, rowData) => clickEdit(rowData),
                }),
              ]}
              options={{
                exportButton: {
                  csv: true,
                  pdf: false,
                },
                exportAllData: true,
                exportFileName: "ViewSlip",
                pageSize: 50,
                pageSizeOptions: [50, 75, 100],
                search: false,
              }}
            />
          </Grid>
        </Grid>

        <Dialog
          open={openLoader}
          //onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          id="templateUploadSuccess"
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              borderColor: "transparent",
            },
          }}
        >
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>

        <Dialog
          open={openForm}
          disableBackdropClick
          maxWidth={"lg"}
          aria-labelledby="edit-dialog-title"
          onClose={handleeditFormClose}
        >
          <DialogContent>
            <UpdateSlipInventory
              clickgoback={goBackonClick}
              editData={editRowData}
              Mode={mode}
              createdUserId={CreatedUserId}
            />
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
